export default "__VITE_ASSET__DE_tPi1N__"